import { ModalType } from '@/types/stores/modal/modal-type.enum';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ModalBase from './ModalBase';
import PaymentPendingModal from './payment/PaymentPendingModal';
import PaymentFailedModal from './payment/PaymentFailedModal';
import useModalStore from '@/stores/modal.store';
import PaymentCompletedModal from './payment/PaymentCompletedModal';
import CancelOrderModal from './order/CancelOrderModal';
import CreatePayoutAccountModal from './payout-account/CreatePayoutAccountModal';
import ActivatePayoutAccountModal from './payout-account/ActivatePayoutAccountModal';
import AuthenticationPendingModal from './auth/AuthenticationPendingModal';
import AuthenticationFailedModal from './auth/AuthenticationFailedModal';
import AddMembersModal from './member/add-members.modal';
import CreateSaleModal from './sale/create-sale.modal';

export default function ModalRoot() {
  const type = useModalStore((state) => state.type);
  const props = useModalStore((state) => state.props);
  const close = useModalStore((state) => state.close);

  const MODAL_COMPONENTS: Record<ModalType, React.FC<any>> = {
    [ModalType.PaymentPending]: PaymentPendingModal,
    [ModalType.PaymentFailed]: PaymentFailedModal,
    [ModalType.PaymentCompleted]: PaymentCompletedModal,

    [ModalType.CancelOrder]: CancelOrderModal,

    [ModalType.CreatePayoutAccount]: CreatePayoutAccountModal,
    [ModalType.ActivatePayoutAccount]: ActivatePayoutAccountModal,

    [ModalType.AuthenticationPending]: AuthenticationPendingModal,
    [ModalType.AuthenticationFailed]: AuthenticationFailedModal,

    [ModalType.AddMembers]: AddMembersModal,

    [ModalType.CreateSale]: CreateSaleModal,
  };

  if (!type) return null;

  const ModalComponent = MODAL_COMPONENTS[type];

  return ReactDOM.createPortal(
    <ModalBase isOpen={Boolean(ModalComponent)} close={close}>
      <ModalComponent {...props} />
    </ModalBase>,
    document.body,
  );
}
